import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

import { ROLE_HK_USER } from '../shared/constants';
import { DeclarationsAuthService } from './declarations-auth.service';

@Component({
  selector: 'ad-hk-user',
  changeDetection: ChangeDetectionStrategy.Eager,
  template: `
    @if (isAuthorized) {
      <span> <ng-content></ng-content></span>
    }
  `
})
export class HkUserComponent implements OnInit {
  public isAuthorized!: boolean;

  constructor(private authService: DeclarationsAuthService) {}

  ngOnInit(): void {
    this.authService.hasRole$(ROLE_HK_USER).subscribe((hasRole) => (this.isAuthorized = hasRole));
  }
}
